import { Link } from 'react-router-dom';
import { CONTROLADOR } from '@/config/controlador';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="font-titulo text-3xl font-bold text-tinta mb-8">Sobre o Portal Simulados</h1>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-tinta mb-3">O que é</h2>
            <p className="text-gray-600 leading-relaxed">
              O Portal Simulados é uma plataforma para criar, aplicar e corrigir simulados e acompanhar o desempenho das
              turmas. O professor monta a prova com questões objetivas e discursivas — com fórmulas, figuras, gráficos e
              tabelas —, escolhendo do acervo ou importando as suas, de arquivos Word e PDF.
            </p>
          </section>

          {/* O que existe HOJE (01/11/2026, aprovado pelo pesquisador). Mudou um recurso, mude aqui. */}
          <section>
            <h2 className="text-xl font-semibold text-tinta mb-3">Três formas de aplicar</h2>
            <ul className="text-gray-600 space-y-2 list-disc list-inside">
              <li><strong>Online:</strong> o aluno responde no navegador ou no aplicativo, no celular ou no computador; as objetivas são corrigidas na hora, e as discursivas pelo professor.</li>
              <li><strong>No papel:</strong> caderno da turma ou prova individual em PDF, com a folha de respostas lida pela câmera do celular ou enviada em fotos ou PDF.</li>
              <li><strong>Na sala sem internet:</strong> o professor abre a sala no aplicativo do computador (Windows e Mac) ou no celular ou tablet (iPhone e iPad, ou Android, em teste), e os alunos entram pelo celular ou pelo computador, na rede local da sala, sem internet. O professor acompanha ao vivo — quem entrou, em que questão está, mais tempo, recado —, e os resultados vão ao portal quando houver internet.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-tinta mb-3">Relatórios</h2>
            <ul className="text-gray-600 space-y-2 list-disc list-inside">
              <li>Desempenho por habilidade, com a escolha da matriz (Saeb, BNCC, Enem ou conteúdo), por questão (com a análise das alternativas) e por turma.</li>
              <li>Faixas de desempenho como distribuição da turma (abaixo do básico, básico, adequado e avançado; convenção do portal, e não a escala do Saeb), e a taxa de acerto de cada aluno ao longo dos simulados.</li>
              <li>O Relatório do simulado em PDF, para a escola, e o relatório de cada aluno.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-tinta mb-3">Onde usar</h2>
            <p className="text-gray-600 leading-relaxed">
              No navegador; no aplicativo para iPhone e iPad (App Store) e para Android (em teste); e no aplicativo para
              Windows e macOS, que abre a sala sem internet.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-tinta mb-3">Desenvolvedor</h2>
            <p className="text-gray-600 leading-relaxed">
              <strong>{CONTROLADOR.nome}</strong>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-tinta mb-3">Contato</h2>
            <p className="text-gray-600">
              E-mail:{' '}
              <a href={`mailto:${CONTROLADOR.contato}`} className="text-marca-600 hover:underline">
                {CONTROLADOR.contato}
              </a>
            </p>
          </section>

          <div className="pt-4 border-t">
            <Link to="/" className="text-marca-600 hover:underline text-sm">
              Voltar para a página inicial
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
